import { useEffect, useState, FunctionComponent } from 'react';
import { Typography, IconButton, Paper, Avatar, TextField } from '../../tailwindcomponents';
import certificateApi from '../../api/certificates'
import { Send, Visibility } from '../icons';
import { Comments } from '../../types/messages';

type MessageBoxProps = {
    id: number | null,
    editMode: Boolean,
    type: 'Shop' | 'Certificate',
}

const MessageBox: FunctionComponent<MessageBoxProps> = ({ id, editMode, type }) => {
    const [allComments, setAllComments] = useState(Array<Comments>())
    const [message, setMessage] = useState("");
    useEffect(() => {
        refresh()
        //Todo: Remove this perhaps?
        const escFunction = (event: any) => {
            const keyCode = event.keyCode;
        }
        document.addEventListener('keydown', escFunction, false)
    }, [])
    const refresh = () => {
        if (id !== null) {
            if (type === "Certificate") {
                certificateApi.GetMessagesCertificateId(id).then(res => {
                    if (res.status === true) {
                        setAllComments(res.data)
                        const element = document.getElementById("message-box-container")!;
                        element.scrollTop = element.scrollHeight;
                    } else {
                        setAllComments([])
                    }
                })
            }


        } else {
            //Create Ticket
        }
    }
    const onSendMessage = () => {
        if (type === "Certificate") {
            certificateApi.AddMessage(id!, message).then(res => {
                refresh()
                setMessage("")
                const element = document.getElementById("message-box-container")!;
                element.scrollTop = element.scrollHeight;
            })
        }
    }
    return (
        <div>
            <div id="message-box-container" className="overflow-y-scroll max-h-[500px]">
                {
                    allComments.map(row => {
                        return (
                            <div>
                                {
                                    row.is_my_message === true ?
                                        <div className="flex flex-wrap items-center mt-2 justify-end" >
                                            <div>
                                                <Typography margin={[0, 2, 0, 2]} fontWeight='bold' text={row.created_by_employee_name} />
                                                <Typography margin={[-1, 2, 0, 2]} text={row.created_date_text} />
                                            </div>
                                            <Avatar alt="user profile pic" src={row.created_by_employee_user_image} style={{ width: 24, height: 24 }} />
                                            <div className="w-3/4">
                                                <Paper elevation={16} style={{ backgroundColor: 'rgb(0,132,255)' }}>
                                                    <Typography padding={[1, 1, 1, 1]} textColor='white' text={row.message} />
                                                </Paper>
                                            </div>
                                            {row.seen_by_employee_name != null &&
                                                <div className="w-full flex flex-wrap justify-end">
                                                    <Visibility />
                                                    <Typography text={`${row.seen_date_text} ${row.seen_by_employee_name}`} />
                                                </div>
                                            }
                                        </div>
                                        :
                                        <div className="flex flex-wrap items-center mt-2">
                                            <Avatar alt="user profile pic" src={row.created_by_employee_user_image} style={{ width: 24, height: 24 }} />
                                            <div>
                                                <Typography margin={[0, 2, 0, 2]} fontWeight='bold' text={row.created_by_employee_name} />
                                                <Typography margin={[-1, 2, 0, 2]} text={row.created_date_text} />
                                            </div>
                                            <div className="w-3/4">
                                                <Paper elevation={16} style={{ backgroundColor: 'rgb(229,230,235)' }}>
                                                    <Typography padding={[1, 1, 1, 1]} text={row.message} />
                                                </Paper>
                                            </div>
                                            {row.seen_by_employee_name != null &&
                                                <div className="w-full flex flex-wrap ml-2.5">
                                                    <Visibility />
                                                    <Typography text={`${row.seen_date_text} ${row.seen_by_employee_name}`} />
                                                </div>
                                            }

                                        </div>
                                }
                            </div>
                        )
                    })
                }
                <br />
            </div>
            {editMode === true && <div className="flex flex-wrap w-full">
                <div className="w-11/12">

                    <Paper>
                        <TextField
                            id="outlined-multiline-flexible"
                            label="Aa"
                            multiline
                            maxRows={40}
                            value={message}
                            fullWidth={true}
                            onChange={(e: any) => setMessage(e.target.value)}
                        />
                    </Paper>
                </div>
                <div className="w-1/12">
                    <IconButton id="send-message" onClick={() => onSendMessage()}>
                        <Send className="h-[30px] w-[30px] mt-[7px] ml-[3px]" color='primary' />
                    </IconButton>
                </div>
            </div>}
        </div>
    );
};
export default MessageBox;